import { Box } from "@mui/material";
import CustomDialog from "components/CustomDialog";
import TrayCreateInWizardForm from "pages/vending/machine/create/TrayCreateInWizardForm";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { clearMachineState } from "store/reducers/vending";

const AddMoreTrays = ({ machine, open, handleClose }) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(clearMachineState());
  }, [dispatch, open]);
  return (
    <CustomDialog
      fullScreen={false}
      open={open}
      handleClose={handleClose}
      heading="Add more trays"
    >
      <Box paddingX={2}>
        <TrayCreateInWizardForm machine={machine} fullGrid={true} />
      </Box>
    </CustomDialog>
  );
};

export default AddMoreTrays;
